import React, { useEffect, useState } from "react";
import { fetchMutation, fetchQuery } from "../../../actions";
import { GET_NOTES_TEMPLATES_DATA, UPDATE_NOTES } from "../../notes/actions/notesAct";
import { ShowAlert } from "../../../common/alert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import ViewSamplePopupComp from "../components/ViewSamplePopupComp";

const ViewSamplePopupCont = ({ templateId, setShowTempSummary, onModalTapped }) => {
   const [templateSummary, setTemplateSummary] = useState(null);
   const [loading, setLoading] = useState(false);
   const getNotesGenerate = () => {
      setLoading(true);
      let obj = {};
      let notesTemplate = {
         id: templateId,
      };
      obj.notesTemplate = notesTemplate;
      fetchQuery(
         GET_NOTES_TEMPLATES_DATA,
         obj,
         (res) => {
            const notesData = res?.data?.getNotesTemplate?.template[0];
            setTemplateSummary(notesData);
            setLoading(false);
         },
         (err) => {
            ShowAlert(errorToDisplay(err), "error");
            setLoading(false);
         }
      );
   };

   const UpdateNotes = (id, isDisabled, onError = () => {}) => {
      let notesObj = {};
      notesObj = {
         notesTemplate: {
            id: id,
            isDisable: isDisabled,
         },
      };
      fetchMutation(
         UPDATE_NOTES,
         notesObj,
         (res) => {
            // const message = res?.data?.upsertNotesTemplate?.status?.message;
            // ShowAlert(message);
            // getNotesTemplate();
         },
         (error) => {
            ShowAlert(errorToDisplay(error), "error");
            onError();
         }
      );
   };

   useEffect(() => {
      getNotesGenerate();
   }, []);

   return (
      <ViewSamplePopupComp
         templateSummary={templateSummary}
         UpdateNotes={UpdateNotes}
         loading={loading}
         onModalTapped={onModalTapped}
      />
   );
};

export default ViewSamplePopupCont;
